
<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :export-data-options="exportDataOptions" />
</template>

<script>
import { mapState } from 'vuex'
import ColumnsMixin from '../mixins/columns'
import singleActionsMixin from '../mixins/singleActions'
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getNameFilter, getStatusFilter } from '@/utils/common/tableFilter'

export default {
  name: 'TechSupportList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, singleActionsMixin],
  props: {
    id: String,
    isBackend: Boolean,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'customerservices',
        filterOptions: {
          name: getNameFilter(),
          status: getStatusFilter({ statusModule: 'saasTechSupport' }),
        },
      }),
    }
  },
  computed: {
    // exportDataOptions () {
    //   return {
    //     items: this.columns,
    //     title: '技术支持',
    //     exportType: 'local',
    //   }
    // },
    ...mapState('app', {
      customer_level: state => state.customerCapability.customer_level,
      certified_status: state => state.customerCapability.certified_status,
    }),
    groupActions () {
      return [
        {
          label: this.$t('scope.apply_tech_support'),
          action: () => {
            /* this.onManager('create', {
              managerArgs: {
                data: {
                  project_id: this.$store.getters.userInfo.projectId,
                  project_domain_id: this.$store.getters.userInfo.projectDomainId,
                },
              },
            }) */
            this.createDialog('SaasTechSupportCreateDialog', {
              onManager: this.onManager,
            })
          },
          meta: () => ({
            buttonType: 'primary',
            validate: this.customer_level > 1,
            tooltip: this.customer_level < 2 ? '请先到账户中心完成个人实名认证' : '',
          }),
          hidden: (obj) => this.isBackend,
        },
      ]
    },
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'SaasTechSupportSidePage', {
        id: row.id,
        resource: 'customerservices',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
  },
}
</script>

<style lang="less" scoped>
</style>
